
// SVG Icon: right-small
export default { id: "terriajs-right-small" };
export const id = "terriajs-right-small";
export const name = "right-small";
